import { IAddEmployee, IGetAll, ILaunchAppraisal } from 'src/app/interface';
import { ICompany, IDeleteAgencyEmployee } from './company.interface';

export namespace Company {
  export class Create {
    static readonly type = '[Company] Create';
    constructor(public payload: ICompany) {}
  }

  export class EditEmployee {
    static readonly type = '[Company] EditEmployee';
    constructor(public payload: IAddEmployee) {}
  }

  export class Delete {
    static readonly type = '[Company] Delete';
    constructor(public id: number) {}
  }

  export class GetAll {
    static readonly type = '[Company] GetAll';
    constructor() {}
  }

  export class GetSingleAgencyEmployee {
    static readonly type = '[Company] GetSingleAgencyEmployee';
    constructor(public payload: any) {}
  }

  export class addEmployee {
    static readonly type = '[Company] addEmployee';
    constructor(public payload: IAddEmployee) {}
  }

  export class DeleteEmployeeFromAgency {
    static readonly type = '[Employee] delete';
    constructor(public payload: IDeleteAgencyEmployee) {}
  }

  export class GetAllEmployee {
    static readonly type = '[Company] GetAllEmployee';
    constructor() {}
  }

  export class launchAppriasal {
    static readonly type = '[Company] launchAppriasal';
    constructor(public payload: ILaunchAppraisal) {}
  }

  export class launchSelfApriasal {
    static readonly type = '[Company] launchSelfApriasal';
    constructor(public payload: any) {}
  }

  export class GetSelfApriasal {
    static readonly type = '[Company] GetSelfApriasal';
    constructor(public payload: any) {}
  }

  export class launchCompetencyApriasal {
    static readonly type = '[Company] launchCompetencyApriasal';
    constructor(public payload: any) {}
  }

  export class GetCompetencyApriasal {
    static readonly type = '[Company] GetCompetencyApriasal';
    constructor(public payload: any) {}
  }

  export class launchNextYearApriasal {
    static readonly type = '[Company] launchNextYearApriasal';
    constructor(public payload: any) {}
  }

  export class revertApriasal {
    static readonly type = '[Company] revertApriasal';
    constructor(public payload: any) {}
  }

  export class GetNextYearApriasal {
    static readonly type = '[Company] GetNextYearApriasal';
    constructor(public payload: any) {}
  }

  export class GetUserIdLocalStorage {
    static readonly type = '[Company] GetUserIdLocalStorage';
    constructor() {}
  }

  export class getMembers {
    static readonly type = '[Company] getMembers';
    constructor(public payload: any) {}
  }

  export class AssignMembers {
    static readonly type = '[Company] AssignMembers';
    constructor(public payload: any) {}
  }
  export class DownloadPDF {
    static readonly type = '[Company] DownloadPDF';
    constructor(public payload: any) {}
  }

  export class GetAllMemberWhoDoneApprisal {
    static readonly type = '[Member] Get All Member Who Done Apprisal';
    constructor(public payload: any) {}
  }
  export class GetAllAgencyMemberWhoDoneApprisal {
    static readonly type = '[Member] Get All Who Done Appraisal';
    constructor(public payload: number) {}
  }

  export class GetAllAgencyOfficeMemberWhoDoneApprisal {
    static readonly type = '[Member] Get All Who Done Appraisal';
    constructor(public payload: any) {}
  }

  export class GetAllAgencyTesting {
    static readonly type = '[Member] Get All Who Done Appraisal';
    constructor(public payload: any) {}
  }

  export class GetAgencyOffices {
    static readonly type = '[Member] Get All Offices';
    constructor(public payload: number) {}
  }
  export class ChangeStatus {
    static readonly type = '[Member] Change Caliberated Status';
    constructor(public payload: any) {}
  }
  export class ManullyChangeStatus {
    static readonly type = '[Member] Manually Change Caliberated Status';
    constructor(public payload: any) {}
  }
}
